import { styled } from '@mui/material';

export type TimelineItemProps = {
  flagImage?: React.ReactElement;
  year: string;
  imageComponent?: React.ReactElement;
  yearTo?: string;
  heading: string;
  text?: string;
  align?: 'top' | 'bottom';
};

export const TimelineItem = ({
  year,
  flagImage,
  imageComponent,
  heading,
  text,
  align = 'top',
}: TimelineItemProps) => {
  return (
    <TimelineItemContainer>
      {flagImage && <FlagImageWrapper>{flagImage}</FlagImageWrapper>}
      {imageComponent && (
        <ImageWrapper align={align}>{imageComponent}</ImageWrapper>
      )}
      <ContentWrapper align={align}>
        <Year>{year}</Year>
        <Heading>{heading}</Heading>
        {text && <Text>{text}</Text>}
        <Icon align={align} />
      </ContentWrapper>
    </TimelineItemContainer>
  );
};

const TimelineItemContainer = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
}));

const ImageWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'align',
})<{ align: string }>(({ align }) => {
  const bottom = align === 'bottom';
  return {
    padding: `${bottom ? '150px' : '0'} var(--spacer-l) ${bottom ? '0' : '150px'}`,
    gridArea: '2 / 1 / 3 / 2',
    width: '322px',

    img: {
      width: '100%',
    },
  };
});

const FlagImageWrapper = styled('div')(() => ({
  borderLeft: '1px solid var(--color-black)',
  gridArea: '1 / 2 / 2 / 3',
  paddingBottom: 'var(--spacer-l)',

  img: {
    width: '127px',
    height: '100px',
  },
}));

const ContentWrapper = styled('div')<{ align: string }>(({ align }) => {
  const bottom = align === 'bottom';

  return {
    borderLeft: '1px solid var(--color-black)',
    padding: `${bottom ? '150px' : '0'} var(--spacer-l) ${bottom ? '0' : '150px'}`,
    gridArea: '2 / 2 / 3 / 3',
    position: 'relative',
    width: '322px',
  };
});

const Year = styled('h4')(({ theme }) => ({
  ...theme.typography.h4,
  color: 'var(--color-light-red)',
  margin: '0',
}));

const Heading = styled('h6')(({ theme }) => ({
  ...theme.typography.h6,
  margin: 'var(--spacer-xxs) 0 0',
}));

const Text = styled('p')(({ theme }) => ({
  ...theme.typography.body,
  margin: 'var(--spacer-xxs) 0 0',
}));

const Icon = styled('div')<{
  align: string;
}>(({ align }) => {
  const bottom = align === 'bottom';
  return {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-light-red)',
    position: 'absolute',
    left: '-25px',
    bottom: bottom ? 'auto' : '0',
    top: bottom ? '0' : 'auto',
  };
});
